import { RoomType } from 'pages/common/types';
import { LayingType } from 'pages/common/components/LayingTypeField/const';
import { ColourType, DoorType, ForWetRoomsType } from './types';

export const doorTypeLabels = {
  GLASS: 'Со стеклянной вставкой',
  BLANK: 'Глухая',
  GLAZED: 'Застеклённая',
};

export const forWetRoomsLabels = {
  YES: 'Да',
  NO: 'Нет',
};

export const colourLabels = {
  WHITE: 'Белый',
  SILVER: 'Серый / серебристый',
  BEIGE: 'Бежевый',
  BROWN: 'Коричневый',
  BLACK: 'Чёрный',
  YELLOW: 'Жёлтый / золотой',
  GREEN: 'Зелёный',
};

export const iconColors = {
  SILVER: '#EAEAEA',
  BEIGE: '#FAE7C9',
  BROWN: '#80542F',
  BLACK: '#1D1D1D',
  YELLOW: '#FFE553',
  GREEN: '#398261',
};

export const parametersGALabels = {
  doorType: 'Модель двери',
  forWetRooms: 'Для влажных помещений',
  colour: 'Цвет',
  roomType: 'Комната укладки',
  lengthAndWidth: 'Длина x ширина',
  area: 'Площадь',
  layingType: 'Направление укладки',
};

export const colourGALabels = {
  ...iconColors,
  WHITE: '#FFFFFF',
};

export const forWetRoomsGALabels = {
  true: 'Да',
  false: 'Нет',
};

export const formNames = {
  INTERIOR_DOORS: 'door-project-form',
  LAMINATE: 'laminate-project-configuration-form',
};

export const catalogueLevels = {
  SECOND: 2,
  THIRD: 3,
};

export const KAZAKHSTAN_REGION_ID = '40';

export const userProjectConfigurationCookieNames = {
  INTERIOR_DOORS: 'calculators_userProjectConfiguration',
  LAMINATE: 'calculators_userProjectConfigurationLaminat',
};

export const drawerHeaderHeight = {
  INTERIOR_DOORS: 56,
  LAMINATE: 32,
  LAMINATE_MOBILE: 0,
};

export const SNACKBAR_TIMEOUT = 5000;

export const CUSTOMER_ID_COOKIE_NAME = 'customerId';

export const UNAUTHORIZED_CUSTOMER_ID_COOKIE_NAME = '_ym_uid';

export const configurationTypes = {
  INTERIOR_DOORS: 'INTERIOR_DOORS',
  FLOOR_COVERING: 'FLOOR_COVERING',
};

export const facetsIds = {
  DOOR_TYPE: '09483',
  COLOUR: '10837',
  FOR_WET_ROOMS: '13532',
  THICKNESS: '00596',
  CLASS: '12430',
  WATER_RESISTANCE: '10721',
};

export const doorTypeFacetValues = {
  [DoorType.GLASS]: 'Cо стеклянной вставной панелью',
  [DoorType.BLANK]: 'Глухой',
  [DoorType.GLAZED]: 'Застекленный',
};

export const forWetRoomsFacetValues = {
  [ForWetRoomsType.YES]: 'Да',
  [ForWetRoomsType.NO]: 'Нет',
};

export const colourFacetValues = {
  [ColourType.WHITE]: 'Белый',
  [ColourType.SILVER]: 'Серый / серебристый',
  [ColourType.BEIGE]: 'Бежевый',
  [ColourType.BROWN]: 'Коричневый',
  [ColourType.BLACK]: 'Черный',
  [ColourType.YELLOW]: 'Жёлтый / золотой',
  [ColourType.GREEN]: 'Зеленый',
};

export const projectConfigurationTypes = {
  LAMINATE: 'laminate',
  INTERIOR_DOORS: 'interior-doors',
};

export const thicknessFacetValues = {
  [RoomType.KITCHEN]: ['8.0', '12.0'],
  [RoomType.BATHROOM]: ['8.0', '12.0'],
  [RoomType.LIVING_ROOM]: ['8.0', '12.0'],
  [RoomType.BEDROOM]: ['7.0', '10.0'],
  [RoomType.HALLWAY]: ['8.0', '12.0'],
  [RoomType.NURSERY]: ['7.0', '10.0'],
  [RoomType.OFFICE_SPACE]: ['8.0', '12.0'],
};

export const classFacetValues = {
  [RoomType.KITCHEN]: ['Класс 32', 'Класс 33', 'Класс 34'],
  [RoomType.BATHROOM]: ['Класс 32', 'Класс 33', 'Класс 34'],
  [RoomType.LIVING_ROOM]: ['Класс 32', 'Класс 33', 'Класс 34'],
  [RoomType.BEDROOM]: ['Класс 31', 'Класс 32'],
  [RoomType.HALLWAY]: ['Класс 32', 'Класс 33', 'Класс 34'],
  [RoomType.NURSERY]: ['Класс 31', 'Класс 32', 'Класс 33', 'Класс 34'],
  [RoomType.OFFICE_SPACE]: ['Класс 34'],
};

export const waterResistanceFacetValues = {
  [RoomType.KITCHEN]: ['Да'],
  [RoomType.BATHROOM]: ['Да'],
  [RoomType.LIVING_ROOM]: ['Нет'],
  [RoomType.BEDROOM]: ['Нет'],
  [RoomType.HALLWAY]: ['Да'],
  [RoomType.NURSERY]: ['Нет'],
  [RoomType.OFFICE_SPACE]: ['Да'],
};

export const projectUpdatedCustomEventNames = {
  INTERIOR_DOORS: 'calculators:interiorDoorsProjectUpdated',
  LAMINATE: 'calculators:laminatProjectUpdated',
};

export const configurationPriceCoefficient = {
  [LayingType.horizontal]: '1.05',
  [LayingType.diagonal]: '1.15',
};
